// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__zRjDC","title":"styles_title__2E3VH"};